<div class="container-fluid px-0">
  <app-event-list></app-event-list>
</div>
